// extracted by mini-css-extract-plugin
export default {"nav":"NavbarWide_nav__pVaUQ","logo":"NavbarWide_logo__UxbYF","items":"NavbarWide_items__d7i+m","borderActive":"NavbarWide_borderActive__iqmax"};